module.exports = __webpack_public_path__ + "static/media/exukonline-delivered-car.5df1bbdb.png";